import { criarParticipante } from '@/uteis/action/tramite/participante'

export const criarFinalizador = (dadosSessao, isAdicionarUsuario) => {
  var finalizador = criarParticipante(dadosSessao.nomeUsuario, dadosSessao.login, 'LOGIN')

  return finalizador
}
